import { createSlice } from '@reduxjs/toolkit';
import { getItemFromStorage, setItemInStorage } from 'Utils/storage';

export const authDataSlice = createSlice({
  name: 'saveData',
  initialState: {
    user: getItemFromStorage('user') || {},
  },
  reducers: {
    updateAuth: (state, action) => {
      setItemInStorage('user', action.payload);
      state.user = action.payload;
    },
  },
});

export const { updateAuth } = authDataSlice.actions;

export default authDataSlice.reducer;
